module.exports = require('../../../data.json');



// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/data.js